/**
 * Demo fixtures shared by the Content Blocks pages.
 *
 * Requires are written out in full rather than built from a template — a
 * dynamic `require(\`…/product-${n}.jpg\`)` makes webpack bundle the whole
 * directory as a context module.
 */

export const HERO_IMAGE = require('../../../../../assets/cls-dk/landing/hero-studietur.jpg');

export const DEMO_PRODUCTS = [
  { id: 1, image: require('../../../../../assets/cls-dk/products/product-1-1.jpg'), imageAlt: 'Hoodie Navy', title: 'HOODIE NAVY', price: '159,-', colors: ['#2e2e52', '#afafaf'], href: '#' },
  { id: 2, image: require('../../../../../assets/cls-dk/products/product-2-1.jpg'), imageAlt: 'Hoodie Grey', title: 'HOODIE GREY', price: '159,-', colors: ['#2e2e52', '#afafaf'], href: '#' },
  { id: 3, image: require('../../../../../assets/cls-dk/products/product-3-1.jpg'), imageAlt: 'Crewneck Navy', title: 'CREWNECK NAVY', price: '159,-', colors: ['#2e2e52', '#afafaf'], href: '#' },
  { id: 4, image: require('../../../../../assets/cls-dk/products/product-4-1.jpg'), imageAlt: 'Crewneck Grey', title: 'CREWNECK GREY', price: '159,-', colors: ['#2e2e52', '#afafaf'], href: '#' },
  { id: 5, image: require('../../../../../assets/cls-dk/products/product-5-1.jpg'), imageAlt: 'Product', title: 'PRODUCT NAME', price: '159,-', colors: ['#6f6f6f', '#2f2f2f', '#aad1ce', '#aad1b2', '#dccee1', '#ea9fa0', '#3d88dc', '#c4c4c4'], href: '#' },
  { id: 6, image: require('../../../../../assets/cls-dk/products/product-6-1.jpg'), imageAlt: 'Product', title: 'PRODUCT NAME', price: '159,-', colors: ['#6f6f6f', '#2f2f2f', '#aad1ce'], href: '#' },
  { id: 7, image: require('../../../../../assets/cls-dk/products/product-7-1.jpg'), imageAlt: 'Product', title: 'PRODUCT NAME', price: '159,-', colors: ['#6f6f6f', '#2f2f2f', '#aad1ce', '#aad1b2', '#dccee1'], href: '#' },
  { id: 8, image: require('../../../../../assets/cls-dk/products/product-8-1.jpg'), imageAlt: 'Product', title: 'PRODUCT NAME', price: '159,-', colors: ['#6f6f6f', '#2f2f2f', '#aad1ce'], href: '#' },
];

export const DEMO_PACKAGES = [
  { id: 9, image: require('../../../../../assets/cls-dk/products/package-1-1.jpg'), imageAlt: 'Hoodie & Sweatpants', title: 'HOODIE & SWEATPANTS', description: 'Pakkeløsning', price: '299,-', colors: ['#080c0a', '#293a35', '#28e280'], href: '#' },
  { id: 10, image: require('../../../../../assets/cls-dk/products/package-2-1.jpg'), imageAlt: 'Festival pakke', title: 'FESTIVAL PAKKE', description: 'Pakkeløsning', price: '399,-', colors: ['#080c0a', '#ffffff'], href: '#' },
  { id: 11, image: require('../../../../../assets/cls-dk/products/package-3-1.jpg'), imageAlt: 'Hoodie & T-shirt', title: 'HOODIE & T-SHIRT', description: 'Pakkeløsning', price: '249,-', colors: ['#080c0a', '#6b1d2e', '#1e2a4a'], href: '#' },
  { id: 12, image: require('../../../../../assets/cls-dk/products/package-1-1.jpg'), imageAlt: 'Komplet pakke', title: 'KOMPLET PAKKE', description: 'Pakkeløsning', price: '499,-', colors: ['#080c0a', '#293a35'], href: '#' },
];

/* ── OVER/LL-shaped fixtures for the Overall content blocks (HeroBannerV3, USPV2,
 * ContentBannerV2, BentoGrid, PatchBurst): sample content in the shape the blocks
 * take — a copy of the Overall landing data so the docs never import brand page
 * code. Prices and counts are literals here on purpose. ── */

import configuratorDesktop from '@ajat/design-system/assets/overall/landing/configurator-desktop.jpg';
import configuratorMobile from '@ajat/design-system/assets/overall/landing/configurator-mobile.jpg';
import heroVideo from '@ajat/design-system/assets/overall/landing/overall_patch_animation_v2_9s.mp4';
import heroStill from '@ajat/design-system/assets/overall/landing/overall_start-end_frame_v2.png';

import edition1 from '@ajat/design-system/assets/overall/landing/editions/edition-1.jpg';
import edition2 from '@ajat/design-system/assets/overall/landing/editions/edition-2.jpg';
import edition3 from '@ajat/design-system/assets/overall/landing/editions/edition-3.jpg';
import edition4 from '@ajat/design-system/assets/overall/landing/editions/edition-4.jpg';
import edition5 from '@ajat/design-system/assets/overall/landing/editions/edition-5.jpg';
import edition6 from '@ajat/design-system/assets/overall/landing/editions/edition-6.jpg';

import kvaliteDetail1 from '@ajat/design-system/assets/overall/landing/kvalite/detail-1.jpg';
import kvaliteFabricRed from '@ajat/design-system/assets/overall/landing/kvalite/fabric-red.jpg';
import kvaliteDetail3 from '@ajat/design-system/assets/overall/landing/kvalite/detail-3.jpg';
import kvaliteDetail4 from '@ajat/design-system/assets/overall/landing/kvalite/detail-4.jpg';

import patchAfterSki from '@ajat/design-system/assets/overall/landing/patches/after-ski.png';
import patchQueen from '@ajat/design-system/assets/overall/landing/patches/queen.png';
import patchIron from '@ajat/design-system/assets/overall/landing/patches/iron-feature.jpg';
import patchOoops from '@ajat/design-system/assets/overall/landing/patches/ooops.png';
import patchOverllExtra from '@ajat/design-system/assets/overall/landing/patches/overll-extra.png';
import patchSpicyGirls from '@ajat/design-system/assets/overall/landing/patches/spicy-girls.png';
import patchDolceBanana from '@ajat/design-system/assets/overall/landing/patches/dolce-banana.png';
import patchTongue from '@ajat/design-system/assets/overall/landing/patches/tongue.png';
import patchBornToWin from '@ajat/design-system/assets/overall/landing/patches/born-to-win.png';
import patchTungTung from '@ajat/design-system/assets/overall/landing/patches/tung-tung.png';
import patchRelax from '@ajat/design-system/assets/overall/landing/patches/relax.png';
import patchMoney from '@ajat/design-system/assets/overall/landing/patches/money.png';
import patchCaptcha from '@ajat/design-system/assets/overall/landing/patches/captcha.png';

import stickerBaddie from '@ajat/design-system/assets/overall/landing/stickers/baddie.png';
import stickerLifeSucks from '@ajat/design-system/assets/overall/landing/stickers/life-sucks.png';

/**
 * Patches that materialise around the headline while it resolves (HeroBannerV3
 * `burst` → PatchBurst). Authored, not random: x/y in % of the text column,
 * size = width px, rotate = resting tilt, delay from scene start, one of
 * pop-flick / swing-shrink / lift-vanish. The hero schedules the scene so the
 * LAST patch is gone at REVEAL_TIMING.burstEnd — only the stagger matters here.
 * 4 patches on both breakpoints, in the order born-to-win → tongue →
 * dolce-banana → money (72ms apart, the last one 116ms so it reads as its own beat) (up to four on screen for a beat —
 * the price of fitting the scene inside the text). Every spot is free space in
 * the current layout — desktop: above the eyebrow, right of the short title
 * lines, the left gutter, beside the CTA row; mobile (measured on a 390px
 * phone, title = "OFFICIAL UNIFORM / OF UNOFFICIAL / BEHAVIOR"): the eyebrow
 * row's right end (eyebrow ends ~57%), right of "OF UNOFFICIAL" (ends ~77%,
 * y ~29%), the gap right of "BEHAVIOR" (ends ~52%, y ~42%), and the beige area
 * under the overall's feet at the visual's bottom-left (negative y). The copy
 * and the CTA row run the full width — nothing goes there. `mobile: false`
 * would skip a patch on phones.
 */
export const HERO_BURST = [
  { id: 'born-to-win', image: patchBornToWin, x: 64, y: 12, size: 84, rotate: 8, delay: 0, motion: 'pop-flick', mobile: { x: 80, y: 3, size: 48 } },
  { id: 'dolce-banana', image: patchDolceBanana, x: 82, y: 38, size: 116, rotate: -6, delay: 144, motion: 'swing-shrink', mobile: { x: 78, y: 42, size: 76 } },
  { id: 'tongue', image: patchTongue, x: -1, y: 46, size: 60, rotate: -12, delay: 72, motion: 'lift-vanish', mobile: { x: 10, y: -8, size: 44 } },
  { id: 'money', image: patchMoney, x: 72, y: 70, size: 72, rotate: 10, delay: 260, motion: 'pop-flick', mobile: { x: 91, y: 29, size: 40 } },
];

export const HERO = {
  subtitle: 'Designed in Stockholm',
  title: 'Official uniform of',
  titleAccent: 'unofficial behavior',
  copy: 'Designa din studentoverall från grunden eller börja med en edition.',
  ctaLabel: 'Designa editions',
  secondaryLabel: 'Designa free',
  stats: [
    { label: 'Från', value: '299 kr' },
    { label: 'Patchar', value: '500+' },
    { label: 'Basfärger', value: '4' },
  ],
  // Muted 9s loop of the patches landing on the overall (1080×1350); the
  // still is the clip's first/last frame (1280×1600), shown until the clip
  // can play so the hand-over is invisible.
  video: heroVideo,
  image: heroStill,
  imageAlt: 'Vit studentoverall med broderade patchar',
  burst: HERO_BURST,
};

export const USP_ITEMS = [
  { label: 'Leverans', value: '2–4 dagar' },
  { label: 'Grupprabatt', value: 'Från 10 st', hideOnMobile: true },
  { label: 'Betalning', value: 'Kort · Swish' },
  { label: 'Kvalité', value: 'Premium canvas', hideOnMobile: true },
];

export const EDITIONS = {
  caption: 'Trending',
  title: 'EDITIONS',
  ctaLabel: 'Se alla editions',
  items: [
    { id: 'white', title: 'Vit edition', price: '299 kr', image: edition1, imageAlt: 'Vit overall med patchar' },
    { id: 'red', title: 'Röd edition', price: '299 kr', image: edition2, imageAlt: 'Röd overall med patchar' },
    { id: 'black', title: 'Svart edition', price: '299 kr', image: edition3, imageAlt: 'Svart overall med patchar' },
    { id: 'pink', title: 'Rosa edition', price: '299 kr', image: edition4, imageAlt: 'Rosa overall med patchar' },
    { id: 'navy', title: 'Marin edition', price: '299 kr', image: edition5, imageAlt: 'Marinblå overall med patchar' },
    { id: 'white-2', title: 'Vit edition II', price: '299 kr', image: edition6, imageAlt: 'Vit overall med patchar, fram' },
  ],
};

// Fabric weight: Figma 2217:151813 says 280g in the paragraph and 350g in the
// feature row — the feature row (the explicit spec line) wins; confirm with the brand.
export const KVALITE = {
  subtitle: 'Kvalité',
  title: 'Byggd för att hålla',
  paragraph:
    'Vi kompromissar inte med kvalitet. Varje overall sys i 350g premium canvas med förstärkta sömmar och knappar. Varje patch broderas med 15 000+ stygn för maximal hållbarhet.',
  features: [
    { title: '350g premium canvas', description: 'Tung, strukturerad, vacker' },
    { title: 'Nickelfria knappar', description: 'Industristandard. Håller i år.' },
    { title: '15 000+ broderade stygn per patch', description: 'Tål att bäras utan att blekas' },
    { title: 'Etisk produktion', description: 'Certifierat tillverkad i Portugal' },
  ],
  images: [
    { src: kvaliteDetail1, alt: 'Röd overall, ficka med dragkedja' },
    { src: kvaliteFabricRed, alt: 'Vit overall, bröstficka med OVER/LL-märke' },
    { src: kvaliteDetail3, alt: 'Rosa overall, insida med OVER/LL-etikett' },
    { src: kvaliteDetail4, alt: 'Röd overall, nickelfri knapp' },
  ],
};

export const PATCH_UNIVERSE = {
  caption: 'Anpassning',
  title: 'Patch Universe',
  tabs: [
    { id: 'all', label: 'Alla' },
    { id: 'graphic', label: 'Graphic' },
    { id: 'text', label: 'Text' },
  ],
  ctaLabel: 'Se alla patches',
  items: [
    { id: 'after-ski', image: patchAfterSki, alt: 'After Ski', tags: ['graphic', 'text'] },
    { id: 'queen', image: patchQueen, alt: 'Queen', tags: ['graphic'] },
    {
      id: 'iron',
      size: 'feature',
      image: patchIron,
      alt: 'Strykjärn som fäster en patch på en overall',
      title: 'Fäst ditt märke med ett strykjärn',
      linkLabel: 'Discover more',
    },
    { id: 'ooops', image: patchOoops, alt: 'Ooops', tags: ['text'] },
    { id: 'overll-extra', image: patchOverllExtra, alt: 'OVER/LL Extra', tags: ['graphic'] },
    { id: 'spicy-girls', size: 'wide', image: patchSpicyGirls, alt: 'Spicy Girls Club', tags: ['graphic', 'text'] },
    { id: 'dolce-banana', image: patchDolceBanana, alt: 'Dolce & Banana', tags: ['text'] },
    { id: 'tongue', image: patchTongue, alt: 'Tunga', tags: ['graphic'] },
    { id: 'born-to-win', image: patchBornToWin, alt: 'Born to win', tags: ['text'] },
    { id: 'tung-tung', image: patchTungTung, alt: 'Tung Tung Tung Sahur', tags: ['graphic'] },
    { id: 'relax', image: patchRelax, alt: 'Relax', tags: ['text'] },
    { id: 'money', image: patchMoney, alt: 'Sedelbunt', tags: ['graphic'] },
    { id: 'captcha', size: 'wide', image: patchCaptcha, alt: "I'm not a robot", tags: ['text'] },
  ],
};

export const BORJA_DESIGNA = {
  title: 'Börja designa',
  paragraph: 'Välj din bas. Placera dina patchar. Se resultatet i realtid. Din overall, exakt som du vill ha den.',
  steps: [
    'Välj basfärg och modell',
    'Lägg till patchar från Patch Universe',
    'Lägg till text, namn eller klass',
    'Beställ enskilt eller som grupp',
  ],
  ctaLabel: 'Designa nu',
  // Figma shows a video of the configurator; screenshots of /overalls/configurator
  // (desktop 848×446, mobile 334×664 framing) stand in until a clip exists.
  images: [{ src: configuratorDesktop, srcMobile: configuratorMobile, alt: 'Konfiguratorn' }],
  stickers: [
    { src: stickerBaddie, alt: '', position: 'top-left' },
    { src: stickerLifeSucks, alt: '', position: 'top-right' },
  ],
};

/* ── OVER/LL product listing (ProductsGrid `tiles` / `spans`) — Figma OVER-LL
 * SEO text 2699:18385, SEO image 2707:18924, wide card 2699:16566. The copy is
 * the Figma sample copy. ── */

import listingWideRed from '@ajat/design-system/assets/overall/listing/wide-red-edition.jpg';
import listingIron from '@ajat/design-system/assets/overall/listing/seo-iron.jpg';

export const LISTING_FRAME_MARK = require('@ajat/design-system/assets/overall/icon-ovr-logotype.svg');

export const LISTING = {
  caption: 'Collection',
  title: 'TRENDING',
  items: [
    { id: 'white', title: 'Vit edition', price: '299 kr', image: edition1, imageAlt: 'Vit overall med patchar' },
    { id: 'red', title: 'Röd edition', price: '299 kr', image: edition2, imageAlt: 'Röd overall med patchar', selected: true, selectedLabel: 'Our choice' },
    { id: 'black', title: 'Svart edition', price: '299 kr', image: edition3, imageAlt: 'Svart overall med patchar' },
    { id: 'pink', title: 'Rosa edition', price: '299 kr', image: edition4, imageAlt: 'Rosa overall med patchar', selected: true, selectedLabel: 'Girls love it' },
    { id: 'navy', title: 'Marin edition', price: '299 kr', image: edition5, imageAlt: 'Marinblå overall med patchar' },
    { id: 'white-2', title: 'Vit edition II', price: '299 kr', image: edition6, imageAlt: 'Vit overall med patchar, fram' },
  ],
  /* The wide card of Figma 2699:16566 — its photo is a landscape shot */
  wideItem: { id: 'red-wide', title: 'Röd edition', price: '299 kr', image: listingWideRed, imageAlt: 'Röd overall med patchar', selected: true, selectedLabel: 'Red edition' },
  textTile: {
    id: 'memories',
    variant: 'text',
    title: 'Designad för att bära minnen',
    body: [
      'OVER/LL är konstruerad med generösa sömmar och robust canvas - inte för att se bra ut på en galge, utan för att rymma tre år av patchar, märken och minnen. Varje detalj är en inbjudan att göra plagget till ditt eget.',
      'Dragkedjorna är YKK. Tygvikten är 350g/m². Passformen är testad med verkliga studenter, inte skyltdockor.',
    ],
    linkLabel: 'Discover more',
    href: '#',
  },
  imageTile: {
    id: 'iron',
    variant: 'image',
    title: 'Fäst ditt märke med ett strykjärn',
    image: listingIron,
    imageAlt: 'Ett strykjärn fäster en patch på en vit overall',
    linkLabel: 'Discover more',
    href: '#',
  },
};

/* SecondaryBannerV2 — Figma OVER-LL 2699:15510 (the Editions section banner) */
export const EDITIONS_BANNER = {
  breadcrumbs: [
    { label: 'HEM', href: '#' },
    { label: 'EDITIONS', href: '#' },
  ],
  breadcrumbsLabel: 'Brödsmulor',
  title: 'DESIGNA EDITIONS',
  copy: 'Våra Editions är färdigdesignade mallar skapade för att inspirera. Välj en Edition som utgångspunkt och gör den till din egen i vår konfigurator.',
};

/* A light studio photo for the image-surface demo */
export const BANNER_PHOTO = kvaliteFabricRed;

/* ── HeroBannerV4 (Crown Student hero, Figma Crownstudent-MCP 90:26891 / 96:30960) ── */
export const HERO_V4 = {
  title: 'Ett minne\nför livet!',
  copy: 'Vi vill att du ska få den bästa studenten! Detta gör att vi utvecklar de bästa produkterna, år ut och år in. Därför erbjuder vi den högsta kvalitén på alla våra studentmössor och studentprylar!',
  ctaLabel: 'Designa nu!',
  image: require('@ajat/design-system/assets/crownstudent/landing/hero-students.webp'),
  imageMobile: require('@ajat/design-system/assets/crownstudent/landing/hero-students-mobile.webp'),
  imageAlt: 'Fem studenter i vita studentmössor',
  usps: [
    { label: 'Högsta kvalité' },
    { label: 'Fri Frakt' },
    { label: 'Prisvärda' },
    { label: 'Leverans: 2026-11-27' },
  ],
};

export const FOMO_V4 = {
  image: require('@ajat/design-system/assets/crownstudent/landing/hero-cap.png'),
  imageAlt: 'Vit studentmössa med guldbrodyr',
  deliveryLabel: 'Garanterad leverans',
  deliveryDate: '2026-11-27',
  countdownLabel: 'Beställ inom',
  // a day ahead of the page load, so the demo ticks
  deadline: new Date(Date.now() + 26 * 60 * 60 * 1000).toISOString(),
  countdownUnits: { days: 'drg', hours: 'tim', minutes: 'min', seconds: 'sek' },
  ctaLabel: 'Börja designa',
};

/* ── ContentBannerV3 (Crown Student «Champagneglas / Studentprylar», Figma Crownstudent-MCP 69:19251 / 129:5943) ── */
export const CONTENT_BANNER_V3 = [
  {
    title: 'Designa ditt Champagneglas',
    text: 'Välj att gravera ditt namn och årtal på vårt exklusiva champagneglas.',
    image: {
      src: require('@ajat/design-system/assets/crownstudent/landing/champagne-glasses.webp'),
      alt: 'Tre graverade champagneglas med krona och årtal',
    },
    ctaLabel: 'Designa Nu!',
  },
  {
    title: 'Kolla in Studentprylar',
    text: 'Då är det bara studentprylarna kvar och sedan kan nedräkningen börja!',
    image: {
      src: require('@ajat/design-system/assets/crownstudent/landing/student-gear.webp'),
      alt: 'Megafon, visselpipa, flaska och penna med Student-tryck',
    },
    ctaLabel: 'KOLLA IN!',
    ctaHref: '#',
  },
];

/** ContentBannerV4 — the Crown Student info cards (Figma Crownstudent-MCP 69:19626) */
export const CONTENT_BANNER_V4 = [
  {
    chip: 'Gratis',
    title: 'Black Box',
    text: 'Kolla in Black Boxen: flera av Crownstudents allra bästa produkter samlade i en box till dig!',
    image: {
      src: require('@ajat/design-system/assets/crownstudent/landing/black-box.webp'),
      alt: 'Black Box med studentmössor, champagneglas, emblem och tillbehör',
    },
    linkLabel: 'Beställ nu',
  },
  {
    chip: 'Gratis',
    title: 'Storleksguide',
    text: 'Tycker du att studentmössor ser lika bra ut som alla våra kunder tycker, men är osäker på vilken storlek din studentmössa ska ha?',
    image: {
      src: require('@ajat/design-system/assets/crownstudent/landing/size-guide.webp'),
      alt: 'Storleksguiden på en datorskärm',
    },
    linkLabel: 'Få gratis',
  },
  {
    chip: 'Ingår alltid',
    title: 'Trygghet och garantier',
    text: 'Din student är viktig för oss! Vi har valt att enbart arbeta med noga utvalda leverantörer och de bästa producenterna i Europa.',
    image: {
      src: require('@ajat/design-system/assets/crownstudent/landing/guarantees.webp'),
      alt: 'Uppslagen broschyr om trygghet och garantier',
    },
    linkLabel: 'Läs mer',
    linkHref: '#',
  },
];
